import { getCountryCodeByName } from '@/constants/countries';

/**
 * Normalizes a user-entered phone number into E.164-ish form by ensuring the
 * country's dial code prefixes the digits exactly once. Shared by the register
 * page and the login/register modal.
 */
export function formatPhoneNumber(phone: string, country: string): string {
  // Remove all non-digit characters.
  const digits = phone.replace(/\D/g, '');

  // Country dial code, e.g. "+55".
  const countryCode = getCountryCodeByName(country);

  // If the digits already start with the country code, don't add it again.
  if (digits.startsWith(countryCode.replace('+', ''))) {
    return `+${digits}`;
  }

  return `${countryCode}${digits}`;
}
